import { GlobalConstantsTableCols } from "globales-projekt-angular";

export class ConstantsTableColsErgebnisInvBedKe extends GlobalConstantsTableCols {

  static readonly KGE_BEZEICHNUNG: string = 'KGE_BEZEICHNUNG'; 
  static readonly GESAMTPREIS: string = 'GESAMTPREIS';    

  public static getColumns(anzahlGeb: number): string[] {
    let cols: string[] = [this.KGE_BEZEICHNUNG];
   

    for (let i = 0; i < anzahlGeb; i++) { 
      cols.push(this.GESAMTPREIS + "_" + i);
    }
  
    return cols;
  }
}

 